'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var PeerList = require('.');
/**
 * Like PeerList but with a length restriction.
 */


var LimitedPeerList = /*#__PURE__*/function (_PeerList) {
  _inherits(LimitedPeerList, _PeerList);

  var _super = _createSuper(LimitedPeerList);

  /**
   * Create a new limited peer list.
   *
   * @param {number} limit
   */
  function LimitedPeerList(limit) {
    var _this;

    _classCallCheck(this, LimitedPeerList);

    _this = _super.call(this);
    _this.limit = limit;
    return _this;
  }
  /**
   * Add a PeerInfo if it fits in the list
   *
   * @param {PeerInfo} info
   * @returns {bool}
   */


  _createClass(LimitedPeerList, [{
    key: "push",
    value: function push(info) {
      if (this.length < this.limit) {
        return _get(_getPrototypeOf(LimitedPeerList.prototype), "push", this).call(this, info);
      }

      return false;
    }
  }]);

  return LimitedPeerList;
}(PeerList);

module.exports = LimitedPeerList;